$(document).ready(()=>{
  if($('.btn--rounded-default')[0]){
      $('.btn--rounded-default').each(function(){
          if($(this).find('span').length>0){
              if($(this).find('span').text()=="Unlock 20% OFF"){
                  var _thss=$(this);
                  setTimeout(function(){ _thss.attr('target','_blank');},2000);
              }
          }
      });
  }
});